import { config } from "@repo/config";
import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
	locales: Object.keys(config.i18n.locales),
	defaultLocale: config.i18n.defaultLocale,
	localeCookie: {
		name: config.i18n.localeCookieName,
	},
	localePrefix: "as-needed",
	localeDetection: false, // 使用自定义的自动语言设置
	// 中间件默认在响应头 Link 里把所有 locale 都列成 hreflang，不管这页有没有译文，
	// 和页面 <head> 里按 seo.ts 生成的 hreflang 打架（2026-10-22 本地 151 个 sitemap 网址
	// 有 103 个对不上）。hreflang 只由页面 metadata 出
	alternateLinks: false,
});

export const {
	Link: LocaleLink,
	redirect: localeRedirect,
	usePathname: useLocalePathname,
	useRouter: useLocaleRouter,
} = createNavigation(routing);
